export const RequiredSymbol = () => <span>*</span>;